(function () {
    'use strict';

    angular.module("imApp").factory("timeSheetPowTimeListService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 986,
                    parameters: parms || {}
                });
            },
            listPowTimes: function (parms) {
                return $ihttp.post({
                    method: 295,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
